<form @submit.prevent="search" class="vl-form">
    <vl-form-grid mod-stacked>
        <vl-column width="4">
            <label for="documentNumber">Doc nr</label>
            <vl-input-field name="documentNumber" placeholder="Zoek trefwoord" autocomplete="off"
                            v-model="documentNumber" mod-block/>
        </vl-column>
        <vl-column width="4"  v-if="enableCustomerReferenceFilter">
            <label for="customerReference">Eigen referentie</label>
            <vl-input-field name="customerReference" placeholder="Eigen referentie" autocomplete="off"
                            v-model="customerReference" mod-block/>
        </vl-column>
        <vl-column width="4">
            <vl-form-grid mod-stacked>
                <vl-column width="6">
                    <label for="date-from">van</label>
                    <vl-datepicker visual-format="d/m/Y" v-model="dateFrom" id="date-from" :max-date="dateFromMaxDate"/>
                </vl-column>
                <vl-column width="6">
                    <label for="date-to">tot en met</label>
                    <vl-datepicker visual-format="d/m/Y" v-model="dateTo" id="date-to" :min-date="dateToMinDate"/>
                </vl-column>
            </vl-form-grid>
        </vl-column>
        <vl-column width="4" v-if="enableServiceFilter">
            <label for="service">Service</label>            
            <vl-select id="service" name="service" mod-no-placeholder mod-block v-model="service">
                <div v-for="opt in serviceOptions" :key="String(opt.value)">
                    {{opt}}
                </div>
                <option v-for="opt in serviceOptions" :key="String(opt.value)" :value="opt.value">
                    {{ opt.label.toUpperCase() }}
                </option>
            </vl-select>
        </vl-column>
        <vl-column width="4" v-if="enableDocumentTypeFilter">
            <label for="documentType">Type</label>
            <vl-select id="documentType" name="documentType" mod-no-placeholder mod-block v-model="selectedDocumentType">
                <option v-for="opt in documentTypeOptions" :key="String(opt.value)" :value="opt.value">
                    {{ opt.label }}
                </option>
            </vl-select>
        </vl-column>
        <vl-column v-vl-visually-hidden>
            <vl-action-group>
                <vl-button type="submit" v-vl-visually-hidden>Zoeken</vl-button>
            </vl-action-group>
        </vl-column>
    </vl-form-grid>
</form>